import React, { useMemo } from 'react';

import { useFlow, useTrackElement } from '@edreamsodigeo/frontend-core';

import type { TypesOfTrackingEvents } from '@edreamsodigeo/frontend-core';

const EmptyComponent = ({ children }) => children;

const DataMeshSingleTrackedComponent = (event: TypesOfTrackingEvents) =>
  function DataMeshSingleTrackedComponent({
    children = <div />,
    id,
  }: {
    children?: React.ReactNode;
    id: string;
  }) {
    const flow = useFlow();
    const dataMeshFlow = useMemo(
      () => (flow === 'desktop' ? 'DESKTOP' : 'MOBILE'),
      [flow],
    );
    const dataMeshEvent = useMemo(
      () => (event === 'click' ? 'click' : 'load'),
      [],
    );
    const dataMeshId = useMemo(
      () => `${dataMeshEvent}::${dataMeshFlow}::${id}`,
      [dataMeshEvent, dataMeshFlow, id],
    );

    const EVENT_LIST: TypesOfTrackingEvents[] = [event];

    const trackingRef = useTrackElement<HTMLDivElement>(
      EVENT_LIST,
      dataMeshId,
    ) as never;

    return <div ref={trackingRef}>{children}</div>;
  };

export const DataMeshComponentDisplayed =
  DataMeshSingleTrackedComponent('display');

export const DataMeshComponentClicked = DataMeshSingleTrackedComponent('click');

export const DataMeshTrackedComponent = ({
  children = <div />,
  id,
  load = false,
  click = false,
}: {
  children?: React.ReactNode;
  id: string;
  load?: boolean;
  click?: boolean;
}) => {
  const LoadTracking = load ? DataMeshComponentDisplayed : EmptyComponent;
  const ClickTracking = click ? DataMeshComponentClicked : EmptyComponent;
  return (
    <LoadTracking id={id}>
      <ClickTracking id={id}>{children}</ClickTracking>
    </LoadTracking>
  );
};
